export function OutlinePrintIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.696 20.999L11.7952 19.3958L14.2288 15.8535L17.9823 20.999"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.98267 20.9997L9.73137 17.1406L11.7953 19.3966"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9824 12.998H5.98267V20.9994H17.9824V12.998Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.98259 15.9978H4.90262C3.84184 15.9978 2.98267 15.1386 2.98267 14.0779V8.918C2.98267 7.85723 3.84184 6.99805 4.90262 6.99805H19.0623C20.123 6.99805 20.9822 7.85723 20.9822 8.918V14.0779C20.9822 15.1386 20.123 15.9978 19.0623 15.9978H17.9823"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9824 3H5.98267V6.9983H17.9824V3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9807 9.99805H16.9839"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
